<template>
    <div
        data-test-class="reviews-cycles-list-item"
        class="clickable"
        tabindex="0"
        @click="
            reviewCycleUpdateStatus({
                reviewCycleId: reviewCycle._id,
                entrypoint: 'admin',
                type: reviewCycle.type,
            })
        "
        @keyup.enter="
            reviewCycleUpdateStatus({
                reviewCycleId: reviewCycle._id,
                entrypoint: 'admin',
                type: reviewCycle.type,
            })
        "
    >
        <!-- Draft -->
        <div v-if="reviewCycle.type === 'adminDraft'">
            <span>
                <a class="skill-title fake-link">
                    <strong>{{ reviewCycle.name.slice(0, 90) }}</strong>
                    <span v-show="reviewCycle.name.length > 90">...</span>
                </a>
                <br />
                <span class="color-grey">
                    {{ $t(`reviews.list.sDraft`) }}
                </span>
            </span>
        </div>
        <!--/Draft -->

        <!-- Active -->
        <div v-else>
            <div>
                <a class="skill-title fake-link">
                    <strong>{{ reviewCycle.name.slice(0, 105) }}</strong>
                    <span v-show="reviewCycle.name.length > 105">...</span>
                </a>
                <span class="pull-right color-grey hidden-xs">
                    <span>{{ type }}</span>

                    <i class="fal fa-calendar-times-o l-default-margin-s r-default-maring-s"></i>
                    {{ reviewCycle.deadline | moment("MMM DD, YYYY") }}
                </span>
            </div>

            <div v-if="reviewCycle.stats" class="row" style="margin-top: 15px">
                <div class="col-md-3">
                    <div class="progress progress-xs"></div>
                    <p class="color-grey" style="margin-top: -10px">
                        {{
                            $t(`reviews.admin.statusParticipants`, {
                                count: reviewCycle.stats.participants,
                            })
                        }}
                    </p>
                </div>
                <div
                    v-b-popover.hover.top="{
                        content: $t(`reviews.admin.statusSummary`, {
                            started: reviewCycle.stats.selfEvaluations.started,
                            completed: reviewCycle.stats.selfEvaluations.completed,
                            total: reviewCycle.stats.selfEvaluations.total,
                        }),
                    }"
                    class="col-md-3"
                >
                    <div class="progress progress-xs">
                        <div
                            v-if="reviewCycle.stats.selfEvaluations.pStarted"
                            class="progress-bar progress-bar-warning btn-light"
                            :style="`width:${reviewCycle.stats.selfEvaluations.pStarted}%;`"
                        ></div>
                        <div
                            v-if="reviewCycle.stats.selfEvaluations.pCompleted"
                            class="progress-bar progress-bar-primary"
                            :style="`width:${reviewCycle.stats.selfEvaluations.pCompleted - 3}%;`"
                        ></div>
                    </div>
                    <p class="color-grey" style="margin-top: -10px">
                        {{ $t(`reviews.admin.statusSelfEvaluations`) }}
                    </p>
                </div>
                <div
                    v-b-popover.hover.top="{
                        content: $t(`reviews.admin.statusSummary360`, {
                            started: reviewCycle.stats._360Reviews.started,
                            completed: reviewCycle.stats._360Reviews.completed,
                            total: reviewCycle.stats._360Reviews.total,
                        }),
                    }"
                    class="col-md-3"
                >
                    <div class="progress progress-xs">
                        <div
                            v-if="reviewCycle.stats._360Reviews.pStarted"
                            class="progress-bar progress-bar-warning btn-light"
                            :style="`width:${reviewCycle.stats._360Reviews.pStarted}%;`"
                        ></div>
                        <div
                            v-if="reviewCycle.stats._360Reviews.pCompleted"
                            class="progress-bar progress-bar-primary"
                            :style="`width:${reviewCycle.stats._360Reviews.pCompleted - 3}%;`"
                        ></div>
                    </div>
                    <p class="color-grey" style="margin-top: -10px">
                        {{ $t(`reviews.admin.status360Reviews`) }}
                    </p>
                </div>
                <div
                    v-b-popover.hover.top="{
                        content: $t(`reviews.admin.statusSummaryManager`, {
                            started: reviewCycle.stats.managerReviews.started,
                            completed: reviewCycle.stats.managerReviews.completed,
                            shared: reviewCycle.stats.managerReviews.shared,
                            signed: reviewCycle.stats.managerReviews.signed,
                            total: reviewCycle.stats.managerReviews.total,
                        }),
                    }"
                    class="col-md-3"
                >
                    <div class="progress progress-xs">
                        <div
                            v-if="reviewCycle.stats.managerReviews.pStarted"
                            class="progress-bar progress-bar-warning btn-light"
                            :style="`width:${reviewCycle.stats.managerReviews.pStarted}%;`"
                        ></div>
                        <div
                            v-if="reviewCycle.stats.managerReviews.pCompleted"
                            class="progress-bar progress-bar-info"
                            :style="`width:${reviewCycle.stats.managerReviews.pCompleted - 3}%;`"
                        ></div>
                        <div
                            v-if="reviewCycle.stats.managerReviews.pShared"
                            class="progress-bar progress-bar-primary"
                            :style="`width:${reviewCycle.stats.managerReviews.pShared}%;`"
                        ></div>
                        <div
                            v-if="reviewCycle.stats.managerReviews.pSigned"
                            class="progress-bar progress-bar-primary"
                            :style="`width:${reviewCycle.stats.managerReviews.pSigned}%;`"
                        ></div>
                    </div>
                    <p class="color-grey" style="margin-top: -10px">
                        {{ $t(`reviews.admin.statusManagerReviews`) }}
                    </p>
                </div>
            </div>

            <div style="margin-top: 10px">
                <span class="color-grey">
                    <span
                        v-for="(participant, index) in reviewCycle.participants
                            .filter(Boolean)
                            .slice(0, 5)"
                        :key="`${reviewCycle._id}-participant-${index}`"
                    >
                        {{ participant
                        }}<span v-show="index + 1 < reviewCycle.participants.length">, </span>
                    </span>
                    <span v-show="reviewCycle.participants.length > 5">
                        ....
                    </span>
                </span>
            </div>
        </div>
        <!--/Active -->
    </div>
</template>

<script>
export default {
    props: {
        reviewCycle: {
            type: Object,
            required: true,
        },
    },
    computed: {
        type() {
            switch (this.reviewCycle.type) {
                case "adminUpcomingNew":
                    return this.$t(`reviews.list.sNew`);

                case "adminOngoingPeerNominationsPending":
                    return this.$t(`reviews.list.sPeerNominationsPending`);

                case "adminOngoingPeerApprovalPending":
                    return this.$t(`reviews.list.sPeerApprovalPending`);

                case "adminOngoingPeerReviewsPending":
                    return this.$t(`reviews.list.sPeerReviewsPending`);

                case "adminOngoingManagerReviewsPending":
                    return this.$t(`reviews.list.sManagerReviewsPending`);

                case "adminOngoingConversationsPending":
                    return this.$t(`reviews.list.sConversationsPending`);

                case "adminComplete":
                    return this.$t(`reviews.list.sComplete`);

                default:
                    return "";
            }
        },
    },
    methods: {
        reviewCycleUpdateStatus(opts) {
            this.$router.push(`/reviews/cycles/edit/${opts.reviewCycleId}`);
        },
    },
};
</script>
